// extracted by mini-css-extract-plugin
export default {"acp-fulfilment-bookings-list":"nu2vyg6SL3HBrzQt37tY","platform-name":"EkQ5RUsZnqAv8bkPOZsl"};